import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { JurisdictionsEnum } from '@libs/backend-common';
import { useQuery } from '@apollo/client';
import { meQuery } from '@libs/graphql';

import { bitnetLogo, CrexoneLogo, CrexoneLogoBlack } from 'src/assets';
import {
  useApiResponse,
  useAppDisclaimer,
  useJurisdictionDetector,
  useRefreshToken,
  useRenderObjectByTheme,
  useTranslation,
} from 'src/hooks';

import UserDetails from '../user-details/UserDetails';
import ActiveSwapsNav from '../active-swaps-navigation/ActiveSwapsNavigation';

import { JurisdictionRenderer } from '../jurisdiction-renderer/JurisdictionRenderer';
import { useDashboardNavItems } from './hooks/useDashboardNavItems';
import DashboardNavItem from './component/DashboardNavItem';
import {
  Nav,
  NavWrapper,
  PaddingWrapper,
  UserDetailsWrapper,
  HomePage,
  BitnetLogo,
  Shadow,
  SupportNav,
  OffersTitle,
  CustomDropdown,
} from './styles';

export const DASHBOARD_NAV_WIDTH = 27.7;

export const DEFAULT_NAV_WITDTH_WITH_PADDING = DASHBOARD_NAV_WIDTH;

const DashboardNav = ({
  testId = 'dashboardNav',
  isUnderConstruction,
}: {
  testId?: string;
  isUnderConstruction?: boolean;
}) => {
  useRefreshToken();

  const { data, loading: DetailsLoading } = useQuery(meQuery);
  useApiResponse({
    data,
    loading: DetailsLoading,
  });
  const { colors } = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { navigationItems, supportNavigationItems, navigationItemsSecondHalf } =
    useDashboardNavItems();
  const crexonelogo = useRenderObjectByTheme(CrexoneLogoBlack, CrexoneLogo);

  const handleNavigate = () => {
    navigate('/');
  };

  const { currentJurisdiction } = useJurisdictionDetector();

  const navShwadowBackground = useRenderObjectByTheme(
    'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FBFBFB 100%)',
    'linear-gradient(180deg, rgba(34, 37, 48, 0) 0%, #15161d 100%)'
  );

  const isGlobalJurisdiction = currentJurisdiction === JurisdictionsEnum.UA;

  const { isAppDisclaimerVisible } = useAppDisclaimer();

  return (
    <Nav
      data-cy={testId}
      isUnderConstruction={isUnderConstruction}
      isAppDisclaimerVisible={isAppDisclaimerVisible}
    >
      <HomePage data-cy="bitnetLogo" onClick={handleNavigate}>
        <BitnetLogo src={isGlobalJurisdiction ? crexonelogo : bitnetLogo} />
      </HomePage>
      <UserDetailsWrapper>
        <UserDetails imgSize={4.4} />
      </UserDetailsWrapper>
      <NavWrapper>
        <PaddingWrapper>
          {navigationItems.map((item) => (
            <DashboardNavItem item={item} key={item.title} />
          ))}
        </PaddingWrapper>
        {!!navigationItemsSecondHalf.length && (
          <PaddingWrapper>
            <OffersTitle
              type="caption"
              fontFamily="primaryRegular"
              color={colors.text.secondary}
            >
              {t('common_offers')}
            </OffersTitle>
            {navigationItemsSecondHalf.map((item) => (
              <DashboardNavItem item={item} key={item.title} />
            ))}
          </PaddingWrapper>
        )}
        <JurisdictionRenderer
          acceptedJurisdictions={[JurisdictionsEnum.GE, JurisdictionsEnum.EU]}
        >
          <SupportNav>
            <CustomDropdown title={t('common_more')}>
              {supportNavigationItems.map((item) => (
                <DashboardNavItem item={item} key={item.title} />
              ))}
            </CustomDropdown>
          </SupportNav>
        </JurisdictionRenderer>
      </NavWrapper>
      <JurisdictionRenderer acceptedJurisdictions={[JurisdictionsEnum.UA]}>
        <Shadow shadow={navShwadowBackground} />
        <ActiveSwapsNav />
      </JurisdictionRenderer>
    </Nav>
  );
};

export default DashboardNav;
